/*
     Menu functionality
     - Adding Affix to menu on scroll
     - mega menu drop down
     - Mobile menu functionality
 */
     const header = document.querySelector('header.header__block');
     if (header) {
         const headerBlock = header.querySelector('.header__inner-wrapper');
         const mainNavigation = header.querySelector('.header__navigation');
         const navigationItems = mainNavigation.querySelectorAll('.header__link-main');
         const megaMenu = header.querySelector('.header__navigation-contents');
         const portalAndCta = header.querySelector('.header__search-portal-and-cta-wrapper');
         const hamburger = header.querySelector('.hamburger');
     
         document.addEventListener('DOMContentLoaded', function () {
             window.addEventListener('scroll', function () {
                 if (header.classList.contains('header__affix-blocked')) {
                     return;
                 }
                 let triggerPoint = 250; // Default to 250px scrol
                 if (window.scrollY > triggerPoint) {
                     header.classList.add('affix'); // Add class when past trigger point
                 } else {
                     header.classList.remove('affix'); // Remove class when scrolled back up
                 }
             });
         });
     
         mainNavigation.addEventListener('mouseleave', function () {
             const activeNavigation = mainNavigation.querySelector('.header__link-main-active');
             if (activeNavigation && !document.body.classList.contains('mega-menu-active')) {
                 activeNavigation.classList.remove('header__link-main-active');
             }
         });
     
         portalAndCta.addEventListener('mouseover', function () {
             const activeNavigation = mainNavigation.querySelector('.header__link-main-active');
             if (activeNavigation) {
                 activeNavigation.classList.remove('header__link-main-active');
             }
             megaMenu.classList.remove('header__navigation-contents--open');
             document.body.classList.remove('mega-menu-active');
         });
     
         navigationItems.forEach((item) => {
             headerBlock.addEventListener('mouseleave', function () {
                 megaMenu.classList.remove('header__navigation-contents--open');
                 const activeMegaMenu = megaMenu.querySelector('.navigation__mega-menu.active');
                 if (activeMegaMenu) {
                     activeMegaMenu.classList.remove('active');
                 }
                 const activeNavigation = mainNavigation.querySelector('.header__link-main-active');
                 if (activeNavigation) {
                     activeNavigation.classList.remove('header__link-main-active');
                 }
                 document.body.classList.remove('mega-menu-active');
             });
     
             item.addEventListener('mouseover', function () {
                 const activeNavigation = mainNavigation.querySelector('.header__link-main-active');
                 if (activeNavigation) {
                     activeNavigation.classList.remove('header__link-main-active');
                 }
                 item.classList.add('header__link-main-active');
                 
                 if (item.classList.contains('header__link-mega')) {
                     document.body.classList.add('mega-menu-active');
                     const megaMenuContent = megaMenu.querySelectorAll('.navigation__mega-menu');
                     const matchId = 'mega-menu-' + item.getAttribute('data-mega-menu');
                     megaMenuContent.forEach((content) => {
                         content.classList.remove('active');
                         if (content.id === matchId) {
                             content.classList.add('active');
                         }
                     });
                     megaMenu.classList.add('header__navigation-contents--open');
                 } else {
                     megaMenu.classList.remove('header__navigation-contents--open');
                     document.body.classList.remove('mega-menu-active');
                 }
             });
         });
     
         // Mobile menu
         hamburger.addEventListener('click', () => {
             const mobileMenu = document.querySelector('.header__navigation-contents');
             mobileMenu.classList.toggle('header__navigation-contents--open');
             hamburger.classList.toggle('active');
             document.body.classList.toggle('mobile-menu-active');
         });
     }

// Truncate excerpts
document.addEventListener('DOMContentLoaded', function () {
    const excerptElems = document.querySelectorAll('.excerpt');
    excerptElems.forEach(function(excerptElem) {
        const rawText = excerptElem.getAttribute('data-excerpt');
        // Trim the text first to remove any trailing spaces
        const trimmedText = rawText.trim();
        const finalText = trimmedText.length > 180 ? 
            trimmedText.substring(0, 180).trim() + '…' : 
            trimmedText;
        excerptElem.textContent = finalText;
    });
});
